<div id="payee-name-container">
    <div *ngIf="useStandingAuth" class="payee-details">
        <label data-testid="payeeNameLabel" class="label-text">Payee name</label>
        <div class="payeeLine" *ngFor="let payee of defaultPayee; let i = index">
            <span [id]="'checkInputPage_payeeLine-' + (i + 1)"
                [attr.data-testid]="'payeeLine-' + (i + 1)">{{payee}}</span>
        </div>
    </div>
    <div *ngIf="!useStandingAuth" class="payee-name-input-container" >
        <div>
            <mm-text-input-control id="transactionDetailsCheck_thirdPartyPayeeInputField"
                data-testid="transactionDetailsCheck_thirdPartyPayeeInputField" *ngIf="modifiedPayeeEnabled ? isThirdParty : true" [parentForm]="parentForm"
                [inputControlModel]="payeeNameModel" [errorMessage]="payeeNameError">
            </mm-text-input-control>
            <mm-select-dropdown-control id="transactionDetailsCheck_firstPartyPayeeDropdownField"
                data-testid="transactionDetailsCheck_firstPartyPayeeDropdownField" *ngIf="modifiedPayeeEnabled && isThirdParty === false" [parentForm]="parentForm"
                [selectModel]="firstPartyPayeesSelectOptions" [defaultValue]="payeeName"></mm-select-dropdown-control>
            <div *ngIf="!isThirdParty && modifiedPayeeEnabled" class="checkbox-line-container row">
                <div class="col modified-payee-col" [formGroup]="parentForm">
                    <input type="checkbox" class="modified-checkbox" id="checkInputPage_ModifiedPayeeCheckbox"
                        formControlName="modifiedPayeeCheckbox">
                    <label class="modified-payee-label1" for="checkInputPage_ModifiedPayeeCheckbox">Use</label>
                    <mm-tooltip [textTooltip]="true" [position]="'right'">
                        <tooltip-content>
                            <span [innerText]="modifiedPayeeTooltipVerbiage"></span>
                        </tooltip-content>
                        <tooltip-trigger-element>
                            <span>modified payee name</span>
                        </tooltip-trigger-element>
                    </mm-tooltip>
                    <label class="modified-payee-label2" for="checkInputPage_ModifiedPayeeCheckbox">instead</label>
                </div>
            </div>
            <div *ngIf="isThirdParty && !showAdditionalPayee1 && !shouldDisableFieldForEditQcd" id="add-payee-link">
                <a id="transactionDetailsCheck_addAnotherPayeeLink1" data-testid="addAnotherPayeeLink1"
                    (click)="addAdditionalPayee1()">
                    <div class="plus-circle-icon"></div> Add another payee
                </a>
            </div>
        </div>
        <div *ngIf="showAdditionalPayee1">
            <div class="row">
                <div class="col left">
                    <mm-text-input-control [parentForm]="parentForm" [inputControlModel]="additionalPayee1Model"
                        [errorMessage]="payeeNameError">
                    </mm-text-input-control>
                </div>
                <div class="col" id="remove-payee-link-container">
                    <span *ngIf="!showAdditionalPayee2 && !shouldDisableFieldForEditQcd" class="remove-link"><a data-testid="additionalPayee1RemoveLink"
                            (click)="removeAdditionalPayee1()">Remove</a>
                    </span>
                </div>
            </div>
            <div *ngIf="!showAdditionalPayee2 && !shouldDisableFieldForEditQcd" id="add-payee-link">
                <a id="ransactionDetailsCheck_addAnotherPayeeLink2" data-testid="addAnotherPayeeLink2"
                    (click)="addAdditionalPayee2()">
                    <div class="plus-circle-icon"></div> Add another payee
                </a>
            </div>
        </div>
        <div *ngIf="showAdditionalPayee2">
            <div class="row">
                <div class="col left">
                    <mm-text-input-control [parentForm]="parentForm" [inputControlModel]="additionalPayee2Model"
                        [errorMessage]="payeeNameError">
                    </mm-text-input-control>
                </div>
                <div class="col" id="remove-payee-link-container">
                    <span *ngIf="!shouldDisableFieldForEditQcd" class="remove-link"><a data-testid="additionalPayee2RemoveLink"
                            (click)="removeAdditionalPayee2()">Remove</a></span>
                </div>
            </div>
        </div>
    </div>
</div>
